
export function handleMenuClick(targetOffsetTop, top) {
  let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
  top = top ? top : 0
  const STEP = 50
  const multiple = window.devicePixelRatio === 1.25 ? 0.8 : 1
  targetOffsetTop = targetOffsetTop * multiple - top
  if (scrollTop > targetOffsetTop) {
    smoothUp()
  } else {
    smoothDown()
  }
  function smoothDown() {
    if (scrollTop < targetOffsetTop) {
      if (targetOffsetTop - scrollTop >= STEP) {
        scrollTop += STEP
      } else {
        scrollTop = targetOffsetTop
      }
      document.body.scrollTop = scrollTop
      document.documentElement.scrollTop = scrollTop
      requestAnimationFrame(smoothDown)
    }
  }
  // 定义往上滑函数
  function smoothUp() {
    if (scrollTop > targetOffsetTop) {
      if (scrollTop - targetOffsetTop >= STEP) {
        scrollTop -= STEP
      } else {
        scrollTop = targetOffsetTop
      }
      document.body.scrollTop = scrollTop
      document.documentElement.scrollTop = scrollTop
      requestAnimationFrame(smoothUp)
    }
  }
}
